import { PieChart as RechartsPieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
import { PieChart } from 'lucide-react';
import type { PromotionMetricsSlice } from '@/client/types/promotion';
import { money, type ColorScale } from './analytics';

export const TierDonut: React.FC<{ slices: PromotionMetricsSlice[]; color: ColorScale }> = ({ slices, color }) => {
  const total = slices.reduce((s, x) => s + x.revenue, 0);

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
      <div className="mb-4 flex items-center gap-2">
        <PieChart className="h-4 w-4 text-emerald-600" />
        <h3 className="text-sm font-semibold text-gray-900">Revenue by package tier</h3>
      </div>

      {total === 0 ? (
        <p className="py-8 text-center text-sm text-gray-400">No purchases in this period.</p>
      ) : (
        <div className="flex items-center gap-4">
          <div className="relative h-44 w-44 shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <RechartsPieChart>
                <Pie data={slices} dataKey="revenue" nameKey="key" cx="50%" cy="50%" innerRadius={52} outerRadius={80} paddingAngle={2}>
                  {slices.map((s) => (
                    <Cell key={s.key} fill={color(s.key)} />
                  ))}
                </Pie>
                <RechartsTooltip formatter={(v: number, name: string) => [money(v), name]} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              </RechartsPieChart>
            </ResponsiveContainer>
            <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-[11px] uppercase tracking-wide text-gray-400">Total</span>
              <span className="text-sm font-semibold text-gray-900">{money(total)}</span>
            </div>
          </div>
          <div className="max-h-44 flex-1 space-y-2 overflow-y-auto pr-1">
            {slices.map((s) => (
              <div key={s.key} className="flex items-center justify-between gap-2 text-sm">
                <span className="flex min-w-0 items-center gap-2 text-gray-700">
                  <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: color(s.key) }} />
                  <span className="truncate">{s.key}</span>
                </span>
                <span className="tabular-nums text-gray-900">
                  {money(s.revenue)}
                  <span className="ml-1 text-[11px] text-gray-400">{(s.share * 100).toFixed(0)}%</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
